<template>
  <div class="home">
    <div class="home-inner">
      <div class="home-content">
        <h1 class="heading heading--primary" v-if="locale !== 'en-au' && locale !== 'en-gb'">
          Trick Out
          <span class="heading__em">Your Boom</span>
        </h1>
        <h1 class="heading heading--primary" v-if="locale === 'en-au' || locale === 'en-gb'">
          Thank
          <span class="heading__em">You</span>
        </h1>
        <p v-if="locale === 'en-au' || locale === 'en-gb'" class="home-content__body">
            Thank you for your interest in myBoom! Unfortunately, due to various circumstances we will need to shut down myBoom in this country and are no longer accepting new orders. We're sorry for the inconvenience and hope we can direct you to one of our other Ultimate Ears speaker products. If you have already placed an order and have questions about it, please contact our support teams through the main Ultimate Ears website or the contact info on your order confirmation.
        </p>
        <p v-else class="home-content__body">
          Welcome to myBOOM Studio. You design it. We build it. And BOOM. In
          {{ locale === "en-au" ? "4-7" : "3-4" }}
          weeks you’ll be rocking the most awesome wireless speaker ever
          created–the BOOM 3–totally customized for you.
          {{
            locale === "en-au" ? "" : "It takes no time and is super easy."
          }}
          Get yours now for only
          <strong>{{ myBOOMPrice }}</strong>
        </p>
        <div class="home-content__links" v-if="locale !== 'en-au' && locale !== 'en-gb'">
          <router-link
            :to="{ name: 'Fabric' }"
            append
            class="btn btn--inverse btn--right btn--home mobile-only"
            data-text="Design Yours"
            >Design Yours</router-link
          >
          <router-link
            :to="{ name: 'Fabric', params: { animate: true } }"
            class="btn btn--inverse btn--right btn--home desktop-only"
            data-text="Design Yours"
            >Design Yours</router-link
          >
          <router-link
            :to="{ name: 'feeling-lucky' }"
            class="btn btn--has-border btn--right btn--home"
            data-text="I'm Feeling Lucky"
            >I'm Feeling Lucky</router-link
          >
          <a
            class="home-content__faq"
            href="https://support.ultimateears.com/en/myboom3/"
            target="_blank"
          >
            <span>Check out the FAQ</span>
          </a>
        </div>
        <div class="home-content__links" v-if="locale === 'en-gb'">
          <a
            class="home-content__faq"
            href="https://www.ultimateears.com/en-gb/wireless-speakers.html"
            target="_blank"
          >
            <span>Check out our other products</span>
          </a>
        </div>
        <div class="home-content__links" v-if="locale === 'en-au'">
          <a
            class="home-content__faq"
            href="https://www.ultimateears.com/en-au/wireless-speakers.html"
            target="_blank"
          >
            <span>Check out our other products</span>
          </a>
        </div>
      </div>
      <div class="product-lineup-faq">
        <transition name="fade-all">
          <div class="product-lineup" v-show="show">
            <transition name="mobile-links">
              <div class="product-lineup__links" v-show="show" v-if="locale !== 'en-au' && locale !== 'en-gb'">
                <router-link
                  :to="{ name: 'Intro' }"
                  class="btn btn--full-width btn--right btn--inverse m-b-sm"
                  data-text="Design Yours"
                  >Design Yours</router-link
                >

                <router-link
                  :to="{ name: 'feeling-lucky' }"
                  class="btn btn--full-width btn--right btn--all-white m-b-sm"
                  data-text="I'm Feeling Lucky"
                  >I&rsquo;m Feeling Lucky</router-link
                >
              </div>
            </transition>
            <transition name="sidespeaker">
              <img
                v-show="show"
                src="/images/hp-left.png"
                alt
                class="product-lineup__item"
              />
            </transition>
            <transition name="centerspeaker">
              <div
                v-show="show"
                class="product-lineup__item product-lineup__item--front"
              >
                <img
                  src="/images/hp-center-shadow-updated.png"
                  alt
                  class="product-lineup__front-speaker-shadow"
                />
                <div class="product-lineup__front-speaker-wrapper">
                  <img
                    src="/images/hp-center-no-shadow-aurora-bora.png"
                    alt
                    class="product-lineup__front-speaker"
                  />
                  <img
                    src="/images/hp-center-white.png"
                    alt
                    class="product-lineup__front-speaker-white"
                  />
                </div>
              </div>
            </transition>
            <transition name="sidespeaker">
              <img
                v-show="show"
                src="/images/hp-right.png"
                alt
                class="product-lineup__item"
              />
            </transition>
          </div>
        </transition>
      </div>
    </div>
    <a
      class="faq"
      v-if="locale !== 'en-au' && locale !== 'en-gb'"
      href="https://support.ultimateears.com/en/boom3/"
      target="_blank"
    >
      <span>Check out the FAQ</span>
    </a>
    <a
      class="faq"
      v-if="locale === 'en-au'"
      href="https://www.ultimateears.com/en-au/wireless-speakers.html"
      target="_blank"
    >
      <span>Check out our other products</span>
    </a>
    <a
      class="faq"
      v-if="locale === 'en-gb'"
      href="https://www.ultimateears.com/en-gb/wireless-speakers.html"
      target="_blank"
    >
      <span>Check out our other products</span>
    </a>
    <div class="animation-measure">
      <Custom
        emphasized-view="front"
        suffix="design"
        :slide-transition="false"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
import Button from "@/components/Button.vue";
import VueCookies from "vue-cookies";
import Custom from "@/views/Custom.vue";
import { getCurrencyFormatter } from "@/helpers";

export default {
  name: "home",
  components: { Button, Custom },
  data() {
    return {
      show: false,
      next: null,
    };
  },
  mounted() {
    // for animations

    imagesLoaded(".product-lineup", () => {
      this.show = true;
    });

    document.querySelector("html").classList.add("full-page");

    // clear out any current configuration
    // if we have a configuration cookie and we're on the homepage we should delete it
    if (VueCookies.isKey("UEB_Configuration")) {
      VueCookies.remove("UEB_Configuration");
    }
    this.$store.commit("clearConfigurationOptions");
    this.$store.commit("editingFeelingLucky", false);
  },
  computed: {
    myBOOMPrice() {
      const formatter = getCurrencyFormatter(
        this.$store.state.locale,
        this.$store.state.currency,
        2
      );
      return formatter.format(this.$store.state.speakerPrice);
    },
    locale() {
      return this.$store.state.locale.toLowerCase();
    },
  },
  methods: {
    tmobile(e) {
      e.preventDefault();
      $.magnificPopup.open({
        items: {
          src: "#tmobileModal",
        },
        type: "inline",
        fixedContentPos: true,
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close"><span class="mfp-close__text">Close</span></button>',
      });
    },
    designYours() {
      console.log("design yours?");
      // e.preventDefault();
      const body = document.querySelector("body");
      const frontSpeaker = document.querySelector(
        ".product-lineup__item--front"
      );
      const frontSpeakerToMove = document.querySelector(
        ".product-lineup__front-speaker-wrapper"
      );
      const details = this.getAnimationDetails();
      // console.log(details);
      body.classList.add("home-animating");
      frontSpeaker.classList.add("product-lineup__item--front-animating");
      // 7.5% is how much translateY is originally
      // 30px is the height of the label on the next page
      // 4px accounts for some differences between the canvas width and image
      frontSpeakerToMove.setAttribute(
        "style",
        `transform: translateX(calc(${details.x}px - 0px)) translateY(calc(${
          details.y
        }px + (7.5% * ${details.scale}) + 21px)) scale(${details.scale})`
      );
      // transform: translateX(-144%) translateY(-23%) scale(0.95);
      frontSpeakerToMove.addEventListener("transitionend", this.animationEnded);
      /*
        simultaneously...
          - move speaker over to new position
            - new position: width 65%, top: 65%, transform translateY(-50%)
              - parent is max 550px wide width inside a max 1200px width container and is centered inside with another item that is 32% wide with 145px margin left
          - sweep speaker from bottom to top to cover it in white (at an angle, left of the sweep is higher than right)
          - fade out the rest of the page
        once the speaker has reached the right place and is fully white, go to the next page
      */
    },
    getAnimationDetails() {
      let animationMeasure = document.querySelector(".animation-measure");
      animationMeasure.style.display = "block";
      let canvasWrapperDetails = document
        .querySelector(".config-canvas-wrapper")
        .getBoundingClientRect();
      let temp = document.createElement("div");
      temp.setAttribute(
        "style",
        "width: 65%; margin-left: auto; height: 0; background-color: green; padding-bottom: 170.1145454545%;"
      );
      document.querySelector(".config-canvas-equalizer").appendChild(temp);
      let futureSpeakerDetails = temp.getBoundingClientRect();
      // console.log(futureSpeakerDetails, "future speaker details");
      let speakerDetails = document
        .querySelector(".product-lineup__front-speaker-wrapper")
        .getBoundingClientRect();
      // console.log(speakerDetails, "current speaker details");
      let destOffset = {
        top: futureSpeakerDetails.top,
        left: futureSpeakerDetails.left,
      };
      let speakerOffset = {
        top: speakerDetails.top,
        left: speakerDetails.left,
      };
      let scale = futureSpeakerDetails.width / speakerDetails.width;
      // console.log(scale, "scale?");
      animationMeasure.style.display = "none";
      // scale up the size so we can get the correct sizing when we animate
      let clonedNode = document
        .querySelector(".product-lineup__front-speaker-wrapper")
        .cloneNode();
      document.querySelector(".product-lineup__item--front").append(clonedNode);
      clonedNode.setAttribute(
        "style",
        `transition: none; transform: scale(${1.4 *
          scale}) translateY(7.5%); position: absolute; top: 0; right: 0; bottom: 0; left: 0; opacity: 0;`
      );
      let clonedSpeakerDetails = clonedNode.getBoundingClientRect();
      // console.log(clonedSpeakerDetails, "updated speaker details");
      // console.log(destOffset.left);
      // console.log(clonedSpeakerDetails.left);
      // console.log("TO RETURN", {
      //   x: (destOffset.left - clonedSpeakerDetails.left) / (1.4 * scale),
      //   y: (destOffset.top - clonedSpeakerDetails.top) / (1.4 * scale),
      //   scale: 1.4 * scale
      // });
      return {
        x: destOffset.left - clonedSpeakerDetails.left,
        y: destOffset.top - clonedSpeakerDetails.top,
        scale: 1.4 * scale,
      };
    },
    animationEnded(e) {
      if (e.propertyName === "transform") {
        const body = document.querySelector("body");
        body.classList.remove("home-animating");
        // this.$router.push("configure/fabric");
        if (this.next) {
          this.next();
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.params.animate) {
      console.log("ANIMATING");
      this.designYours();
      this.next = next;
    } else {
      next();
    }
    console.log("to", to);
    console.log("from", from);
    // next();
  },
};
</script>

<style lang="scss" scoped>
.lowercase {
  text-transform: lowercase !important;
}
@import "../scss/variables";
.m-b-sm {
  margin-bottom: 0.5em;
}
.m-b-md {
  margin-bottom: 1.5em;
}
strong {
  font-weight: bold;
}

.mobile-links-enter-active,
.mobile-links-leave-active {
  transition: opacity 0.25s ease-out;
  transition-delay: 0.5s;
  @media (min-width: 992px) {
    transition-delay: 0;
  }
}
.mobile-links-enter,
.mobile-links-leave-to {
  opacity: 0;
}

.sidespeaker-enter-active,
.sidespeaker-leave-active {
  @media (min-width: 992px) {
    transition: opacity 0.5s ease-out, transform 0.75s ease-out;
    transition-delay: 1s;
  }
}
.sidespeaker-enter,
.sidespeaker-leave-to {
  @media (min-width: 992px) {
    opacity: 0;
    transform: translateY(20px);
  }
}

.centerspeaker-enter-active,
.centerspeaker-leave-active {
  @media (min-width: 992px) {
    transition: opacity 0.5s ease-out, transform 0.75s ease-out;
    transition-delay: 0.5s;
  }
}
.centerspeaker-enter,
.centerspeaker-leave-to {
  @media (min-width: 992px) {
    opacity: 0;
    transform: translateY(20px);
  }
}

.fade-all-enter-active,
.fade-all-leave-active {
  @media (max-width: 991px) {
    transition-delay: 0.25s;
    transition: opacity 0.5s ease-out;
  }
}

.fade-all-enter,
.fade-all-leave-to {
  @media (max-width: 991px) {
    opacity: 0;
  }
}

.heading {
  font-size: 2em;
  text-align: center;
  margin-bottom: 0.5em;
  @media (min-width: 992px) {
    text-align: left;
    font-size: 2em;
    @media (min-height: 650px) {
      font-size: 2.5em;
    }
    @media (min-height: 750px) {
      font-size: 3em;
    }
  }
  &--primary {
    text-transform: uppercase;
  }
  &__em {
    font-size: 1.5em;
    display: block;
  }
}
.home-inner {
  box-sizing: border-box;
  @media (min-width: 600px) and (max-width: 991px) {
    // height: calc(100% - 60px); // height of "in chicago or miami?" button
    height: 100%;
    overflow: hidden;
  }
  @media (min-width: 992px) {
    height: 100%;
    display: flex;
    padding-left: 1.5em;
    padding-right: 1.5em;
    align-items: center;
    justify-content: flex-start;
  }
}
.home {
  position: relative;
  padding-top: 95px;
  box-sizing: border-box;
  height: 100%;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 2000px) {
    max-width: 1550px;
  }
  // @media (min-width: 2600px) {
  //   // TEMP
  //   background: red;
  //   &:before {
  //     content: '2600px +';
  //     color: #fff;
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //   }
  // }
}
.home-content {
  @media (min-width: 992px) {
    padding-top: 2em;
    padding-bottom: 2em;
    width: 100%;
    max-width: 350px;
    margin-right: 5em;
  }
  // @media (min-width: 2000px) {
  //   margin-right: 10em;
  // }
  &__body {
    font-size: 0.9em;
    font-family: sans-serif;
    color: $greyDark;
    line-height: 1.3;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 1.5em;
    &--warning {
      color: red !important;
      a {
        color: currentColor;
      }
    }
    @media (min-width: 600px) {
      max-width: 400px;
    }
    @media (min-width: 992px) {
      text-align: left;
      margin-left: 0;
      max-width: none;
      color: #000;
      font-size: 1em;
      max-width: 350px;
    }
  }
  &__faq {
    color: #000;
    font-weight: bold;
    text-decoration: none;
    line-height: 1.5;
    border-bottom: 4px solid #000;
    text-transform: uppercase;
    font-size: 0.85em;
    transition: all 0.3s;
    display: none;

    @media (min-width: 992px) {
      display: block;
      &:hover {
        border-color: $greyDark;
      }
    }
  }
  &__t-mobile {
    display: none;
    @media (min-width: 992px) {
      display: block;
      margin-top: 2em;
      @media (min-height: 800px) {
        margin-top: 4em;
      }
      @media (min-height: 900px) {
        margin-top: 6em;
      }
    }

    h3 {
      text-transform: uppercase;
      font-size: 0.9em;
      margin-bottom: 0.5em;
    }
    a {
      color: currentColor;
      font-family: sans-serif;
      @media (min-width: 992px) {
        transition: color 0.25s;
        &:hover {
          color: $greyDark;
        }
      }
    }
  }
  &__links {
    display: none;
    @media (min-width: 600px) {
      display: flex;
      justify-content: center;
    }
    @media (max-width: 991px) {
      .btn--home {
        /* reset to normal button styles for tablet */
        border: 4px solid #000;
        background-image: none;
        padding: 0.9rem 1.3rem;

        &.btn--inverse {
          background-color: black;
          color: white;
        }
        &:first-child {
          margin-right: 1em;
        }
      }
    }
    @media (min-width: 992px) {
      .btn--home {
        margin-bottom: 1em;
      }
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
.t-mobile {
  background: #fff;
  text-align: center;
  color: currentColor;
  font-family: sans-serif;
  text-decoration: none;
  padding: 1em;
  display: block;
  @media (min-width: 600px) {
    padding: 1.25em 0 1em;
  }
  strong {
    display: block;
    text-transform: uppercase;
    font-family: $font;
    margin-bottom: 0.5em;
    @media (min-width: 600px) {
      display: inline-block;
      padding-right: 1em;
      margin-right: 1em;
      border-right: 1px solid #000;
    }
  }
  span {
    display: block;
    text-decoration: underline;
    color: $greyDark;
    font-size: 0.8em;
    @media (min-width: 600px) {
      display: inline-block;
      font-size: 1em;
      text-transform: uppercase;
      font-family: $font;
      font-weight: bold;
      text-decoration: none;
    }
  }
  i {
    @media (min-width: 600px) {
      color: black;
      position: relative;
      border-bottom: 3px solid currentColor;
    }
  }
  @media (min-width: 600px) {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 11;
  }
  @media (min-width: 992px) {
    display: none;
  }
}
.faq {
  background-color: $greyDark;
  color: #fff;
  text-decoration: none;
  display: block;
  text-align: center;
  text-transform: uppercase;
  padding: 1.25em 1.25em 1.5em;
  font-weight: bold;

  span {
    border-bottom: 3px solid currentColor;
  }
  @media (min-width: 600px) {
  }
  @media (min-width: 992px) {
    display: none;
  }
}
.product-lineup-faq {
  @media (min-width: 992px) {
    max-height: 100%;
    align-self: flex-end;
  }
  @media (min-width: 2600px) {
    align-self: center;
  }
}
.product-lineup {
  overflow: hidden;
  position: relative;
  max-height: 50%;

  @media (min-width: 450px) {
    padding-top: 35px;
  }

  @media (min-width: 600px) and (max-width: 991px) {
    margin-top: 2em;
  }
  @media (min-width: 992px) {
    max-height: none;
    overflow: visible;
  }
  @media (min-width: 2600px) {
    padding-top: 0;
  }

  &__item {
    width: 33.33%;
    position: relative;
    top: 7vw;
    display: inline-block;

    @media (min-width: 992px) {
      top: 7vw;
    }
    @media (min-width: 1250px) {
      // top: 75px;
      top: 40px;
    }
    @media (min-width: 2000px) {
      top: 100px;
    }
    @media (min-width: 2600px) {
      top: auto;
    }
    &--front {
      position: relative;
      transition: all 2s;
      top: 0;
      @media (min-width: 992px) {
        top: -30px;
      }
      @media (min-width: 2600px) {
        top: 0;
      }
      img {
        transform-origin: 50% 0;
        &.product-lineup__front-speaker-shadow {
          opacity: 1;
          transition: opacity 0.2s;
          @media (min-width: 2600px) {
            transform-origin: 50% 0;
          }
        }
        &.product-lineup__front-speaker-white {
          opacity: 0;
          z-index: -1;
        }

        &.product-lineup__front-speaker {
          transition: all 0.5s;
          transition-delay: 0.6s;
          clip-path: polygon(0 -20%, 100% 0, 100% 100%, 0 100%);
        }
      }
      z-index: 1;
      &.product-lineup__item--front-animating {
        .product-lineup__front-speaker-wrapper {
          transition: all 1s;
        }
        img {
          &.product-lineup__front-speaker-shadow {
            opacity: 0;
          }
          &.product-lineup__front-speaker-white {
            opacity: 1;
          }
          &.product-lineup__front-speaker {
            clip-path: polygon(0 -20%, 100% 0, 100% 0, 0 -20%);
          }
        }
      }
    }
  }
  &__front-speaker-wrapper {
    transform: scale(1.4) translateY(0);
    transform-origin: 50% 0;
    @media (min-width: 2600px) {
      // transform: scale(1.2) translateY(0);
      transform: scale(1.1) translateY(0);
      transform-origin: 50% 50%;
    }
    .product-lineup__front-speaker {
      position: static;
      transform: scale(1);
    }
    .product-lineup__front-speaker-white {
      transform: scale(1);
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
    }
  }
  &__front-speaker-shadow {
    position: absolute;
    transform: scale(1.75) translateY(0);
    transform-origin: 50% 0;
    @media (min-width: 2000px) {
      top: 19px;
    }
    @media (min-width: 2600px) {
      top: 50%;
      // transform: scale(1.5) translateY(calc(-50% + 22px));
      transform: scale(1.4) translateY(calc(-50% + 28px));
    }
  }
  &__links {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    left: 0;
    right: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    max-width: 60%;
    min-width: 200px;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 600px) {
      display: none;
    }
  }
}

.modal {
  background: #fff;
  position: relative;
  color: #000;

  max-width: 1030px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;

  &--confirm {
    padding-bottom: 4em;
  }

  &--share {
    text-align: center;
    h2 {
      margin-bottom: 1em;
    }
  }

  @media (min-width: 992px) {
    position: relative;
    color: $greyDark;
    h2 {
      color: #000;
    }
  }
  &--buy {
    text-align: center;
  }
  &--transparent {
    background: transparent;
    color: #fff;
    max-width: 100%;
    .btn-group {
      justify-content: center;
      color: #fff;
    }
  }
  &__submit-group {
    position: relative;
    margin-top: 1em;
    @media (min-width: 992px) {
      margin-top: 0;
    }
  }
  &__btn-loader {
    margin-left: 1em;
    position: absolute;
    right: calc(-20px - 1em);
    top: 50%;
    transform: translateY(-50%);
    &--overlay {
      right: auto;
      left: 50%;
      margin: 0;
      transform: translate3d(-50%, -50%, 0);
    }
    &--overlay-white {
      color: #fff;
    }
    &--overlay-black {
      color: #000;
    }
  }
  &__note {
    margin-top: 2em;
  }
  &__content-area {
    padding: 4rem 2rem 2rem;
    margin-top: 3em;

    h3 {
      text-transform: uppercase;
    }
    p {
      line-height: 1.4;
      margin-bottom: 2.35em;
      font-family: sans-serif;
      font-size: 0.8rem;
      color: $greyDark;
      &:last-child {
        margin-bottom: 0;
      }
      @media (min-width: 992px) {
        font-size: 1em;
      }
    }
    a {
      color: currentColor;
    }
    ul {
      list-style: disc outside;
      margin-left: 1.5em;
      margin-bottom: 1em;
      line-height: 1.4;
      li {
        margin-bottom: 0.5em;
        &:last-child {
          margin: 0;
        }
      }
    }

    &--legal {
      color: #000;
      p {
        color: #000;
        font-size: 1em;
        line-height: 1.4;
      }
      h3 {
        margin-bottom: 0.5em;
      }
      ul {
        font-family: sans-serif;
        color: currentColor;
      }
    }
  }
  &__disclaimer {
    margin-bottom: 3em;
    p {
      margin-bottom: 1em;
    }
  }
  &__opt-in {
    @media (min-width: 992px) {
      border-top: 1px solid $greyMidDark;
      padding-top: 2.35em;
      margin-top: 2.35em;
    }
  }
  &__label {
    display: flex;
    align-items: center;
    font-family: sans-serif;
    color: $greyDark;
    position: relative;
    font-size: 0.8rem;
    line-height: 1.38;
    @media (min-width: 992px) {
      font-size: 1rem;
    }
  }
  &__checkbox {
    opacity: 0;
    position: absolute;
    &:checked {
      + .modal__label {
        .modal__fake-checkbox {
          &:before {
            content: "";
            position: absolute;
            top: 1px;
            bottom: 1px;
            right: 1px;
            left: 1px;
            background: transparent url("/images/checkmark-black.png") center
              center no-repeat;
            background-size: contain;
            display: block;
          }
        }
      }
    }
  }
  &__fake-checkbox {
    width: 22px;
    height: 22px;
    min-width: 22px;
    min-height: 22px;
    max-width: 22px;
    max-height: 22px;
    border: 3px solid #000;
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.75rem;
    float: left;
    position: relative;
    left: 0;
    top: 0;
  }
  &__action-area {
    padding: 3em 2rem;
    background-color: $greyLight;
  }
  &__action-group {
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: stretch;
    }
  }
  &__input {
    font-size: 1em;
    padding-left: 1em;
    padding-right: 1em;
    box-sizing: border-box;
    width: 100%;
    border: none;
    font-family: $font;
    font-weight: bold;
    line-height: 50px;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
  &__btn {
    background: #000;
    color: #fff;
    font-family: $font;
    border: none;
    // margin-top: 1em; // removed this because it messes up the sleep on it modal button
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 992px) {
      height: 100%;
    }
  }
  h2 {
    font-size: 1.75em;
    margin-bottom: 0.5em;
    text-transform: uppercase;
  }
  @media (min-width: 768px) {
    &__content-area {
      padding: 75px 2rem 25px;
    }
  }
  @media (min-width: 992px) {
    h2 {
      font-size: 2.75em;
    }
    &__content-area {
      padding: 75px 100px 25px;
    }
    &__action-area {
      padding: 75px 100px 75px;
    }
  }

  // .mfp-close {
  //   background: #000;
  //   color: #fff;
  // }
}

.modal--t-mobile {
  padding: 75px 1.5em 1.5em;
  @media (min-width: 768px) {
    padding: 100px 100px 85px;
  }
  @media (min-width: 992px) {
    padding-right: 160px;
    padding-left: 160px;
  }
}

.store-wrap {
  @media (min-width: 768px) {
    display: flex;
  }
}

.store {
  color: $greyDark;
  font-family: sans-serif;
  @media (max-width: 767px) {
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2.5em;
    &:last-child {
      margin-bottom: 0;
    }
  }
  @media (min-width: 768px) {
    &:first-child {
      margin-right: 65px;
    }
  }
  &__header {
    margin-bottom: 1em;
    @media (max-width: 767px) {
      background: #000;
      color: #fff;
      position: relative;
    }
  }
  &__image {
    display: block;
    @media (max-width: 767px) {
      opacity: 0.25;
    }
  }
  &__header-text {
    @media (max-width: 767px) {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      z-index: 1;
    }
  }
  &__kicker {
    color: $greyMidDark;
    text-transform: uppercase;
    font-family: sans-serif;
    display: block;
    margin-bottom: 0.5em;
    @media (min-width: 768px) {
      font-size: 0.8em;
    }
    @media (min-width: 992px) {
      font-size: 1em;
    }
  }
  &__address {
  }
  &__phone {
    color: black;
    display: block;
    margin-top: 1em;
    @media (min-width: 768px) {
      color: $greyDark;
      font-size: 0.9em;
    }
    a {
      color: currentColor;
      @media (min-width: 768px) {
        text-decoration: none;
      }
    }
    @media (max-width: 767px) {
    }
  }
  &__link {
    font-family: $font;
    color: black;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 3px solid currentColor;
    text-decoration: none;
    display: inline-block;
    margin-top: 1em;
    font-size: 0.9em;
    @media (min-width: 992px) {
      transition: border-color 0.25s;
      &:hover {
        border-color: $greyDark;
      }
    }
  }
  h4 {
    font-size: 1.25em;
    text-transform: uppercase;
    font-family: $font;
    @media (min-width: 768px) {
      color: black;
      margin-bottom: 1em;
    }
    @media (min-width: 992px) {
      font-size: 2em;
    }
  }
}

.home-content {
  transition: opacity 0.5s, transform 0.5s;
  transition-delay: 0.2s;
}
.home-animating {
  .home-content {
    opacity: 0;
    transform: translateX(-30px);
  }
  .product-lineup__item:not(.product-lineup__item--front) {
    transition: opacity 0.5s;
    transition-delay: 0.2s;
    opacity: 0;
  }
}

.animation-measure {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  z-index: -100;
  display: none;
}
</style>
